import { ModalOpenProcess, ModalOpenProcessRef } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { AddressInput as AddressInputGQLType } from "../../../clients/graphqlTypes.js";
import { GetAddressModal, GetAddressModalProps } from "./GetAddressModal.js";

type ModalProps = Partial<
  Omit<GetAddressModalProps, "handleClose" | "handleComplete">
>;

export interface GetAddressProcessRef {
  getAddress: (props: ModalProps) => Promise<AddressInputGQLType | null>;
}

interface Props {}

export const GetAddressProcess = React.forwardRef<GetAddressProcessRef, Props>(
  (_, forwardedRef) => {
    const { t } = useTranslate(["Address", "Global"]);
    const processRef = React.useRef<ModalOpenProcessRef>();
    const resolveRef = React.useRef<
      ((value: AddressInputGQLType | null) => void) | null
    >(null);

    React.useImperativeHandle(forwardedRef, () => ({
      getAddress: (props: ModalProps) => {
        processRef.current?.open(props);
        return new Promise<AddressInputGQLType | null>((resolve, reject) => {
          resolveRef.current = resolve;
        });
      },
    }));

    return (
      <ModalOpenProcess
        ref={processRef}
        Modal={GetAddressModal}
        modalProps={{
          inputLabel: t("Address", { ns: "Address" }),
          handleComplete: async (address, handleClose) => {
            resolveRef.current?.(address);
            handleClose();
          },
          handleClose: () => {
            resolveRef.current?.(null);
          },
        }}
      />
    );
  }
);
